var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCycleInfo2 = function SvgCycleInfo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F89723",
    d: "M6 9h35v7H6zM6 20h21v8H6zM6 32h31v7H6z"
  })));
};
export { SvgCycleInfo2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNiIgeT0iOSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjciIGZpbGw9IiNGODk3MjMiLz4KPHJlY3QgeD0iNiIgeT0iMjAiIHdpZHRoPSIyMSIgaGVpZ2h0PSI4IiBmaWxsPSIjRjg5NzIzIi8+CjxyZWN0IHg9IjYiIHk9IjMyIiB3aWR0aD0iMzEiIGhlaWdodD0iNyIgZmlsbD0iI0Y4OTcyMyIvPgo8L3N2Zz4K";